import { AuditStatus } from '@arhs-fleetback/types/entities/audits';
import { matchPath } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import * as actionTypes from 'modules/audits/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const enableEdition = () => true;

const disabledEdition = () => false;

// By default - If the page is loaded after the creation, the state is automatically set to {isEditing : true}
const fetchAuditRequestReducer = (state, { payload, meta }) =>
  (meta?.isNew && payload.status === AuditStatus.DRAFT) || false;

/**
 * @param {boolean} state
 * @param {import('modules/global/generic.types').LocationChangeAction} action
 * @return {boolean}
 */
const disabledEditionAfterLocationChange = (state, { payload }) => {
  if (state && matchPath(PATH.AUDITS_DETAILED, payload.location.pathname) === null) {
    return disabledEdition();
  }
  return state;
};

export default createReducer(initialState, {
  [actionTypes.ENABLE_EDITION]: enableEdition,
  // Starting a "To start" audit drops it into DRAFT + edit mode (BMWVID-27360 AC-19), so edit mode
  // is a direct reaction to START_SUCCESS rather than an extra dispatch from the saga.
  [actionTypes.START_SUCCESS]: enableEdition,
  [actionTypes.DISABLE_EDITION]: disabledEdition,
  [actionTypes.PUT_SUCCESS]: disabledEdition,
  [actionTypes.FETCH_AUDIT_SUCCESS]: fetchAuditRequestReducer,
  [LOCATION_CHANGE]: disabledEditionAfterLocationChange,
});
